var React = require('react');

function TwitterInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"social-1_logo-twitter","d":"M22.941,5.225a8.5,8.5,0,0,1-2.728.718A4.639,4.639,0,0,0,22.3,3.359a9.049,9.049,0,0,1-3.015,1.148A4.621,4.621,0,0,0,15.907,3,4.733,4.733,0,0,0,11.17,7.737a5.541,5.541,0,0,0,.144,1.077A13.532,13.532,0,0,1,1.551,3.861,4.518,4.518,0,0,0,.9,6.23a4.856,4.856,0,0,0,2.082,3.948A4.385,4.385,0,0,1,.833,9.6v.072a4.7,4.7,0,0,0,3.8,4.594,7.072,7.072,0,0,1-1.22.144,3.5,3.5,0,0,1-.861-.072,4.794,4.794,0,0,0,4.379,3.3,9.272,9.272,0,0,1-5.886,2.01A6.174,6.174,0,0,1-.1,19.581a14.249,14.249,0,0,0,7.322,2.082A13.32,13.32,0,0,0,20.645,8.24V7.666A12.357,12.357,0,0,0,22.941,5.225Z","transform":"translate(0.1 -3)","fill":"#fff"}));
}

TwitterInline.defaultProps = {"width":"23.042","height":"18.663","viewBox":"0 0 23.042 18.663"};

module.exports = TwitterInline;

TwitterInline.default = TwitterInline;
